type RouteLoc = {
  pathname: string;
  search: string;
  hash?: string;
  key?: string;
};
type State = { prev: RouteLoc | null; current: RouteLoc | null };

const INITIAL: State = { prev: null, current: null };

// Volto/connected-react-router triggers on @@router/LOCATION_CHANGE
const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

export default function prevRoute(state: State = INITIAL, action: any): State {
  if (action.type === LOCATION_CHANGE) {
    const loc = action.payload?.location as RouteLoc | undefined;
    if (!loc) return state;
    return { prev: state.current, current: loc };
  }
  return state;
}
